export const dataTableConfig = {
  page_size: 10,
  length_menu: [10, 20, 50],
  show_filter: false,
  show_pagination: true,
  show_info: true,
  show_length_menu: false,
  pagination: "advance",
  sort: false,

  language: {
    length_menu: "Mostrar _MENU_ registros por página",
    filter: "Pesquisar",
    info: "Mostrando " +
      " _START_ " + "a" +
      " _END_ " + "de" +
      " _TOTAL_ " + "registros",
    no_data_text: "Nenhum registro encontrado",
    pagination: {
      first: "Primeiro",
      previous: "Anterior",
      next: "Próximo",
      last: "Último",
    },
  }
};

export const dataTableConfigLaguages = {
  ptBR:{
    length_menu: "Mostrar _MENU_ registros por página",
    filter: "Pesquisar",
    info: "Mostrando " +
      " _START_ " + "a" +
      " _END_ " + "de" +
      " _TOTAL_ " + "registros",
    no_data_text: "Nenhum registro encontrado",
    pagination: {
      first: "Primeiro",
      previous: "Anterior",
      next: "Próximo",
      last: "Último",
    }
  },
  esPA:{
    length_menu: "Mostrar _MENU_ registros por página",
    filter: "Buscar",
    info: "Demostración " +
      " _START_ " + "a" +
      " _END_ " + "de" +
      " _TOTAL_ " + "registros",
    no_data_text: "No se encontraron registros",
    pagination: {
      first: "Primero",
      previous: "Anterior",
      next: "Próximo",
      last: "Último",
    }
  },
  enUS:{
    length_menu: "Show _MENU_ records per page",
    filter: "Search",
    info: "Showing " +
      " _START_ " + "to" +
      " _END_ " + "of" +
      " _TOTAL_ " + "records",
    no_data_text: "No record found",
    pagination: {
      first: "First",
      previous: "Previous",
      next: "Next",
      last: "Last",
    }
  }
}